<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-activity === cca -->
      <div class="ccc">
        <div class="ccc-box custom-item">
          <div class="custom-m-item">
            <div class="cmi-title">{{Modal.title}} </div>
            <div class="cmi-more">更多
              <Icon type="ios-arrow-forward" />
            </div>
            <div class="cmi-brand" style="height: 118px;">
              <img src="@assets/img/template/company-component-cove-8.jpg" style="width:192px;height:62px;">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  // 活动
  name: "custom-company-activity",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function () {
        return {
          info: "活动",
          type: 9,
          isOpen: true,
          title: "活动"
        };
      }
    }
  },
  data () {
    return {
      visible: false, 
    };
  },
  watch: {
    Load (val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    type () {
      return this.Modal.config.type;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      Load: "customCompanyModule/getLoad",
      activeIndex: "customCompanyModule/getActiveIndex"
    }), 
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }), 
    setVisible () {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
  },
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .cccp {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
